export const CUSTOMERS_LIST_UPDATE = 'CUSTOMERS_LIST_UPDATE'
export const CUSTOMERS_LIST_CLEAN = 'CUSTOMERS_LIST_CLEAN'

export const CUSTOMER_UPDATE_PROPS = 'CUSTOMER_UPDATE_PROPS'
export const CUSTOMER_CLEAR = 'CUSTOMER_CLEAR'
